module.exports = __webpack_public_path__ + "media/images/img-realestate-7-4de50ae8.png";